<template>
  <v-card-text class="pa-1">
    <pool-dialog-header>
    </pool-dialog-header>
    <v-card max-height="325" flat class="mt-6">
      <div style="overflow: auto">
        <v-card max-height="320" flat>
          <data-table
            class="gl-accounts__table"
            :headers="headers"
            :selectableRows="true"
            :tableData="getData"
            :tableKey="'account'"
            :selectedRows="selectedAccounts"
            @selectionChanged="changeSelected"
            :noData="'No information to display.'">
          </data-table>
        </v-card>
      </div>
    </v-card>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataTable from '../../../BaseComponents/Table'
import PoolDialogHeader from './PoolDialogHeader'
export default {
  components: {
    DataTable,
    PoolDialogHeader
  },
  data () {
    return {
      selectedAccounts: []
    }
  },
  methods: {
    ...mapActions(['changeGLAccountsCompleted', 'changeGLAccounts', 'fetchData', 'changeData']),
    changeSelected (val) {
      this.currentData('Expense Accounts').forEach(element => { element.isUsed = false }) // turn off all isUsed flag
      val.forEach(element => { element.isUsed = true }) // set isUsed flag just for items we selected
      this.selectedAccounts = val
      if (this.selectedAccounts.length > 0) {
        this.changeGLAccountsCompleted(true)
      } else {
        this.changeGLAccountsCompleted(false)
      }
      this.changeGLAccounts(val)
    }
  },
  computed: {
    ...mapGetters(['currentData', 'currentHeaders', 'currentPool', 'currentPoolStep']),
    getData () {
      return this.currentData('Expense Accounts')
    },
    headers () {
      return this.currentHeaders('Expense Accounts')
    }
  },
  created () {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'setPoolNextStep') {
        if (this.currentPoolStep === 'Accounts') {
          this.fetchData({newPage: 'Expense Accounts', params: { Property: this.currentPool.property, ChargeCode: this.currentPool.chargeCode, Segment: 50 }}).catch(error => { console.log(error.response) })
        }
        if (this.currentPoolStep === 'Spaces') {
          this.changeData({currentPage: 'Expense Accounts', newData: { Property: this.currentPool.property, ChargeCode: this.currentPool.chargeCode, AccountsInUse: this.selectedAccounts }}).catch(error => { console.log(error.response) })
        }
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  }
}
</script>

<style lang="scss" scoped>
  .gl-accounts__table {
    ::v-deep span {
      font-size: 12px;
    }
    ::v-deep thead tr {
      height: 35px !important;
    }
    ::v-deep thead th {
      padding: 0 !important;
      height: 35px !important;
      &:first-child {
        padding-left: 10px !important;
      }
    }
    ::v-deep tbody tr {
      height: 35px !important;
    }
    ::v-deep tbody td {
      padding: 0 !important;
      height: 35px !important;
      &:first-child {
        padding-left: 10px !important;
      }
    }
  }
</style>
